// Our main CSS
import '../css/app.css'

import './modules/header/headerSlideDown'
import './modules/header/headerDropdown'
import './modules/header/scrollAnimation'
import './modules/header/searchToggle'
import { initNotiserLoadMore } from './modules/notiserLoadMore.ts'
import { initRelatedArticlesLoadMore } from './modules/relatedArticlesLoadMore.ts'
import { initArchiveLoadMore } from './modules/archiveLoadMore.ts'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

// Lazy load external ads - only after marketing consent (Cookiebot)
const externalAdSections = document.querySelectorAll<HTMLElement>('[data-external-ad]')
if (externalAdSections.length > 0) {
  let adsInitialized = false

  const initAds = () => {
    if (adsInitialized || !window.Cookiebot?.consent?.marketing) {return}
    adsInitialized = true

    import('./modules/externalAd').then(({ initExternalAds }) => {
      initExternalAds()
    })
  }

  const hideAdSections = () => {
    if (window.Cookiebot?.consent?.marketing) {return}
    externalAdSections.forEach((section) => {
      section.style.display = 'none'
    })
  }

  window.addEventListener('CookiebotOnConsentReady', initAds)
  window.addEventListener('CookiebotOnAccept', initAds)
  window.addEventListener('CookiebotOnDecline', hideAdSections)
  initAds() // kör direkt om Cookiebot redan är klart (cached consent)
}

const mobileMenuWrapper = document.querySelectorAll('.mobileMenuWrapper')
if (mobileMenuWrapper && mobileMenuWrapper !== null) {
  mobileMenuWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const menuButtonWrapper = document.querySelectorAll('.menuButtonWrapper')
if (menuButtonWrapper && menuButtonWrapper !== null) {
  menuButtonWrapper.forEach((wrapper) => {
    import('./MobileMenu/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

const searchResultsWrapper = document.querySelectorAll('.searchResultsWrapper')
if (searchResultsWrapper && searchResultsWrapper !== null) {
  searchResultsWrapper.forEach((wrapper) => {
    import('./SearchResults/index.ts')
      .then((module) => {
        module.default(wrapper as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
        // main.textContent = err.message;
      })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initNotiserLoadMore()
  initRelatedArticlesLoadMore()
  initArchiveLoadMore()

  const jobsSplide = document.querySelectorAll('.jobs-splide')
  if (jobsSplide.length > 0) {
    import('./modules/jobsSlider').then(({ initJobsSlider }) => {
      initJobsSlider()
    })
  }
})

// Newsletter form - lazy load
const newsletterInstances = document.querySelectorAll('.newsletter-form-instance')
if (newsletterInstances.length > 0) {
  let newsletterInitialized = false

  const initNewsletter = () => {
    if (newsletterInitialized || !window.Cookiebot?.consent?.marketing) {return}
    newsletterInitialized = true

    import('./modules/newsletter/newsletterForm').then(() => {
      const DYNAMICS_FORM_ID = '0426497b-67d9-ef11-a730-000d3a665269'
      const DYNAMICS_ORG_ID = '2de60dad-f802-426b-a5c2-1d8a688fe935'
      window.NewsletterForm.init(DYNAMICS_FORM_ID, DYNAMICS_ORG_ID)
    })
  }

  window.addEventListener('CookiebotOnConsentReady', initNewsletter)
  window.addEventListener('CookiebotOnAccept', initNewsletter)
  initNewsletter() // kör direkt om Cookiebot redan är klart (cached consent)
}
